import { ProcessingOverlay, RadioButtonSection, RadioButtonSectionGroup } from '@components'

import { BorderRadius, Modal, Space, Spacing, Text } from '@billy/design-system'
import { ReactElement } from 'react'
import { useTranslation } from 'react-i18next'

import { useCancelInvoiceModal } from '../../contexts/cancelInvoiceModalContext'
import { CancelInvoiceAction } from '../../enums/cancelInvoiceAction'

enum IsInvoiceSent {
  Yes = 'yes',
  No = 'no',
}

export const CancelInvoiceModalBody = (): ReactElement => {
  const { t } = useTranslation()
  const { isCreateCreditNoteAction, isDeleteInvoiceAction, isDeletingInvoice, setActionType } = useCancelInvoiceModal()

  const handleRadioChange = (value: IsInvoiceSent | undefined) => {
    if (value === IsInvoiceSent.Yes) {
      setActionType(CancelInvoiceAction.CreateCreditNote)
    } else if (value === IsInvoiceSent.No) {
      setActionType(CancelInvoiceAction.DeleteInvoice)
    }
  }

  return (
    <Modal.Body>
      {isDeletingInvoice && <ProcessingOverlay borderRadius={BorderRadius.R16} withAnimation />}
      <Text>{t('external_invoices.view.cancel.modal.was_invoice_sent')}</Text>
      <Space />
      <RadioButtonSectionGroup direction="row" fitToWidth spacing={Spacing.S8}>
        <RadioButtonSection<IsInvoiceSent>
          label={t('external_invoices.view.cancel.modal.options.yes')}
          labelVariant="bodyMD"
          onChange={handleRadioChange}
          value={IsInvoiceSent.Yes}
        />
        <RadioButtonSection<IsInvoiceSent>
          label={t('external_invoices.view.cancel.modal.options.no')}
          labelVariant="bodyMD"
          onChange={handleRadioChange}
          value={IsInvoiceSent.No}
        />
      </RadioButtonSectionGroup>
      <Space />
      {isCreateCreditNoteAction && (
        <Text colorVariant="secondary">{t('external_invoices.view.cancel.modal.explanation.create_credit_note')}</Text>
      )}
      {isDeleteInvoiceAction && (
        <Text colorVariant="secondary">{t('external_invoices.view.cancel.modal.explanation.void_invoice')}</Text>
      )}
    </Modal.Body>
  )
}
